export const DogParkRoutes = {
  Breeders: `/dogpark/breeders`,
  BreederAdminUsers: `/dogpark/admins`,
} as const;

export const BreedersSearchBy = {
  BreederId: 'breeder_id',
  BreederAdminId: 'breeder_admin_id',
} as const;
